import '~/assets/scss/pensia.scss'
import Accordion from '~/js/modules/accordion';
import '~/js/modules/calculator-pensia'

window.addEventListener(`DOMContentLoaded`, () => {
  const accordions = document.querySelectorAll(`.accordion`);
  const cart = document.querySelector('.js-cart');
  const buyButton = document.querySelectorAll(`.js-buy`);
  const buyPif = document.querySelector(`.js-buy-pif`);
  const cartButton = document.querySelector(`.js-cart-button`);
  const pifCounter = cartButton.querySelector(`.js-pif-counter`);
  const closeCart = cart.querySelector('.js-close-btn')
  const cartBody = cart.querySelector('.js-cart-body')

  if (accordions.length) {
    accordions.forEach((accordion) => {
      if (!accordion.classList.contains('main-nav__list') && !accordion.classList.contains('service-request--accordion')) {
        new Accordion(accordion)
      }
    });
  }

  document.querySelectorAll('.js-scroll-button').forEach(anchor => {
    anchor.addEventListener('click', function (e) {
      e.preventDefault();
      const block = document.querySelector(this.getAttribute('data-href'))
      const offset = 80; // Offset in pixels

      // Calculate the absolute position on the page
      const elementPosition = block.getBoundingClientRect().top + window.scrollY;
      const offsetPosition = elementPosition - offset;

      // Scroll to the calculated coordinate
      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      });
      //document.querySelector(this.getAttribute('data-href')).scrollIntoView({ block: "end", behavior: "smooth" });
    });
  });

  let update_count = function (up = false) {
    let count = parseInt(pifCounter.textContent)
    let prevCount = count;

    if(up) {
      count++;
    }
    else {
      count--;
    }
    pifCounter.textContent = count.toString();
    cartButton.style.display = count ? 'flex' : 'none';
    if(prevCount == 0 && count == 1) {
      cart.classList.toggle('active');
    }
    if(count == 0) {
      cart.classList.remove('active')
    }
  }

  let delete_pif = function (opn) {
    let ids = buyPif.dataset.openLink.split('=')[1].split(',')
    if (ids.indexOf(opn) !== -1) {
      ids.splice(ids.indexOf(opn), 1);
    }
    buyPif.dataset.openLink = buyPif.dataset.openLink.split('=')[0] + '=' + ids.join(',')
    buyPif.dataset.openKidsLink = buyPif.dataset.openKidsLink.split('=')[0] + '=' + ids.join(',')
  }

  closeCart.addEventListener('click', (e) => {
    cart.classList.toggle('active')
  })

  cartButton.addEventListener('click', (e) => {
    cart.classList.toggle('active')
  })

  buyButton.forEach((bb) => {
    if (bb) {
      bb.addEventListener('click', (e) => {
        e.stopPropagation()
        e.preventDefault()
        bb.classList.toggle('active')

        if(bb.classList.contains('active')) {
          if(parseInt(pifCounter.textContent) != 0) {
            buyPif.dataset.openLink = buyPif.dataset.openLink + ',' + bb.dataset.openId
            buyPif.dataset.openKidsLink = buyPif.dataset.openKidsLink + ',' + bb.dataset.openId
          }
          else {
            buyPif.dataset.openLink = buyPif.dataset.openLink + bb.dataset.openId
            buyPif.dataset.openKidsLink = buyPif.dataset.openKidsLink + bb.dataset.openId
          }
          const newPif = document.createElement('div')
          const deletePif = document.createElement('button')
          const bottomContainer = document.createElement('div')
          const description = '<p class="description">' + bb.dataset.description + '</p>'
          let risk = ''
          update_count(true)

          deletePif.className = 'delete-button'
          deletePif.innerHTML = '<div class="circle">'
          + '<svg class="trs" xmlns="http://www.w3.org/2000/svg">'
          + '<use href="/assets/dist/img/sprite.svg#i-trash"></use>'
          + '</svg>'
          + '</div>';

          for(let i=1;i<=5;i++) {
            if(bb.dataset.risk >= i) {
              risk = risk + '<div class="risk active"></div>'
            }
            else {
              risk = risk + '<div class="risk"></div>'
            }
          }

          const percent = bb.parentNode.querySelector('.percent')

          bottomContainer.className = 'bottom-container'
          bottomContainer.appendChild(deletePif)

          newPif.className = 'pif-card'
          newPif.dataset.pif = bb.dataset.id
          newPif.innerHTML = '<div class="info-container">'
          + '<div class="head">'
          + '<span class="name">' + bb.dataset.name + '</span>'
          + '<div class="risk-container">'
          + risk
          + '</div>'
          + '</div>'
          + description
          + '<div class="growth-container">'
          + (percent ? percent.outerHTML : '')
          + (percent ? '<span class="date">с ' + bb.dataset.start + ' г.</span>' : '<span class="date">Фонд в стадии</br>формирования</span>')
          + '</div>'
          + '</div>'
          + description
          newPif.appendChild(bottomContainer)

          deletePif.addEventListener('click', (e) => {
            document.querySelector('[data-id="' + newPif.dataset.pif + '"]').classList.toggle('active')
            newPif.remove()
            delete_pif(bb.dataset.openId)
            update_count()
          })

          cartBody.appendChild(newPif)
        }
        else {
          delete_pif(bb.dataset.openId)
          document.querySelector('[data-pif="' + bb.dataset.id + '"]').remove()
          update_count()
        }
      })
    }
  });
})
